
export default {

    name: "sendEmail",

    props: ['idmodule', 'page', 'modal', 'parent', 'hook'],

    components: {

    },

    data: function() {

        return {
            dialogTraked: false,
            trackedList: [],
            mailTracked: { id: false, email: false },
            displayTracked: { objet: '', to: '', corp: '' }
        }
    },

    watch: {
        dialogTraked(val) {
            if (val === false) {
                this.trackedList = [];
            }
        }
    },

    methods: {

        showTracked(item) {
            //trackedmailid : l'id de emailsent pour envoi au back et récup des infos
            this.trackedList = []
            if (!item.trackedmailid) return;

            this.$store.dispatch('textOverlay', 'Obtention des informations');
            this.$store.dispatch('getoverlay', true)
            this.API({ type: 'post', url: 'displaymodule', params: { id: this.idmodule, trackedmailid: item.trackedmailid } }).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                    return false;
                }
                this.dialogTraked = true;
                this.trackedList = resp.data;

            })
        }


    },

}